module.exports = __webpack_public_path__ + "img/CA_1_All_fill_registered-BIG.385adefb.png";